exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".service-history-lbl {\n  margin-top: 23px;\n  margin-left: 10px !important; }\n\n.service-history-print-title-section {\n  display: flex;\n  gap: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/locations/print/print.scss
// module id = 1000
// module chunks = 1